import { useTranslation } from 'react-i18next';
import { ModalView } from '@unified-checkout/kit-components';

import styles from './cvv.module.scss';
import visaCVV from '../../assets/icons/card-cvv.png';
import amexCVV from '../../assets/icons/amex-cvv.png';
import closeIcon from '../../assets/icons/close.png';

interface ICVVToolTipModalProps {
  onClose: () => void;
  showModal: boolean;
  customStyle?: { [key: string]: any }
}

export function CVVToolTipModal({ onClose, showModal, customStyle }: ICVVToolTipModalProps) {
  const { t } = useTranslation('card');

  return (
    <ModalView onClose={onClose} showModal={showModal}>
      <>
        <img
          className={styles['close']}
          src={closeIcon}
          onClick={onClose}
          alt="close cvv modal"
        />
        <h3 className={styles['modal-header']}>
          {customStyle?.hintText?.cvvModalTitle || t('CVV_MODAL_HEADER')}
        </h3>
        <div className={styles['modal-content']}>
          <h3 className={styles['modal-content-header']}>
            {customStyle?.hintText?.cvvVisaMastercardQuestion ||
              t('CVV_MODAL_VISA_HEADER')}
          </h3>
          <p className={styles['modal-content-body']}>
            {customStyle?.hintText?.cvvVisaMastercardHint ||
              t('CVV_MODAL_VISA_BODY')}
          </p>
          <img
            className={styles['modal-image']}
            src={visaCVV}
            alt="Master card / Visa card Back"
          />
          <h3 className={styles['modal-content-header']}>
            {customStyle?.hintText?.cvvAmexQuestion ||
              t('CVV_MODAL_AMEX_HEADER')}
          </h3>
          <p className={styles['modal-content-body']}>
            {customStyle?.hintText?.cvvAmexHint || t('CVV_MODAL_AMEX_BODY')}
          </p>
          <img
            className={styles['modal-image']}
            src={amexCVV}
            alt="American Express card Front"
          />
        </div>
      </>
    </ModalView>
  );
}
